module.exports = __webpack_public_path__ + "img/lantern5.33df031d.png";